

import {defineComponent, ref} from "vue";
import WhiteBoxMain from '@/components/WhiteBoxMain.vue';
import {useRoute} from 'vue-router';
import {
  getClientPartnerReviewQuiz, PartnerReviewQuestionResource, PartnerReviewQuizResource,
  partnerReviewStoreAnswerApi
} from '@/api/partnerReviewApi';
import TheModal from '@/components/TheModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import useModal from '@/hooks/useModal';
import ReviewSentRequestQuestionAnswer from '@/components/ReviewSentRequestQuestion.vue';
import RotateLoader from '@/components/RotateLoader.vue';
import router from '@/router';
import {reviewSentRequestDone} from '@/core/constants';
import {notification} from 'ant-design-vue';

export default defineComponent( {
  name: 'ReviewSentRequestPage',
  components: {
    RotateLoader,
    ReviewSentRequestQuestionAnswer,
   BaseButton, TheModal, WhiteBoxMain},
  setup() {
    const route = useRoute();
    const {
      params: { uuid },
    } = route;

    const questions = ref<Array<PartnerReviewQuestionResource & {user_answer?: string | string[] | null }>>([]);
    const entireServerResponse = ref<PartnerReviewQuizResource | null>(null);

    const modalError = ref('');


    const password = ref<string>('');
    const editingQuestionId = ref<number | null>(null);

    const enterPasswordModal = useModal(true);

    const isSaving = ref(false);
    const wasUpdatedAtLeastOneQuestion = ref(false);



    const isQuestionActive = (questionId: number) =>
      editingQuestionId.value !== null && questionId === editingQuestionId.value;


    const handleModalEnter = () => {
      getData();
    }
    const getData = async () => {
      getClientPartnerReviewQuiz(uuid as string, password.value)
      .then(response => {
        entireServerResponse.value = response;
        questions.value = response.partner_review_questions.map(q => ({
          ...q,
          user_answer: q.partner_answer?.answer_value || ''
        }));
        enterPasswordModal.close();
      }).catch(error => {
        modalError.value = error.response.data.message || error.response.data;
      })
    }


    const handleValueUpdate = (questionId: number, val: string) => {
      wasUpdatedAtLeastOneQuestion.value = true;
      const questionIX = getQuestionIndexById(questionId);
      questions.value[questionIX].user_answer = val;
      // saveResponseWithDebounce();
    };

    const getQuestionIndexById = (questionId: number): number => {
      let questionIndex = -1;
      questions.value.forEach((question, ix) => {
        if (question.id === questionId) {
          questionIndex = ix;
        }
      });
      return questionIndex;
    };

    const saveResponse = () => {
      const payload: Record<string | number, string | string[]> = {};
      questions.value.forEach((question) => {
        if (question.user_answer && question.user_answer !== null) {

          payload[question.id] = question.user_answer;

        }
      });

      if(!wasUpdatedAtLeastOneQuestion.value) {
        notification.error({
          message: 'Error!',
          description: "'At least one question should be changed!",
          duration: 8,
        })
        return 0;
      }
    if(!entireServerResponse.value) throw new Error('asd')
      isSaving.value = true;
      partnerReviewStoreAnswerApi({
        request_uuid: uuid as string,
        partner_review_quiz_id: entireServerResponse.value.id,
        answer: payload,
        password: password.value
      })
      .then(() => {
        notification.success({
          message: 'Success!',
          description: "Has been saved successfully",
          duration: 8,
        })
        router.push({
          name: reviewSentRequestDone,
        })
      }).catch(error => {
        notification.error({
          message: 'Error!',
          description: error.message,
          duration: 8,
        })
      }).finally(() => {
        isSaving.value = false;
      })

    };

    return {
      password,
      handleModalEnter,
      enterPasswordModal,
      questions,

      isQuestionActive,
      handleValueUpdate,
      saveResponse,
      modalError,
      isSaving,
    }
  },

});
